import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'm-feature-card',
  template: `
    <div class="m-statistics-feature-card-cell">
      <span><i nz-icon [nzType]="mIcon"></i></span>
      <span>{{ mTitle }}</span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true
})
export class FeatureCardComponent {
  @Input() mTitle = '';
  @Input() mIcon = '';
}
